import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Attach JWT token if present
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("famewar_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});
